<div class="container-fluid p-0">
  <!-- Buscador y botón de crear -->
  <div class="action-bar mb-3">
    <div class="search-container">
      <div class="input-group">
        <input 
          type="text" 
          class="form-control"
          [placeholder]="config.searchPlaceholder" 
          [(ngModel)]="searchTerm"
          (keyup)="searchEntities()"
          [disabled]="loading"
        >
        <span class="input-group-text">
          <i class="bi bi-search" *ngIf="!loading"></i>
          <div class="spinner-border spinner-border-sm" role="status" *ngIf="loading">
            <span class="visually-hidden">Cargando...</span>
          </div>
        </span>
      </div>
    </div>
    <button class="btn btn-create" (click)="createEntity()" [disabled]="loading">
      <i class="bi bi-plus-circle"></i> Crear {{ config.entityName }}
    </button>
  </div>
  
  <!-- Mensaje de error -->
  <div *ngIf="error" class="alert alert-warning mb-3" role="alert">
    <i class="bi bi-exclamation-triangle"></i> {{ error }}
  </div>
  
  <!-- Estado de carga -->
  <div *ngIf="loading && entities.length === 0" class="text-center py-5">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Cargando {{ config.entityNamePlural }}...</span>
    </div>
    <p class="mt-2">Cargando {{ config.entityNamePlural }}...</p>
  </div>
  
  <!-- Lista completa cuando no hay búsqueda -->
  <div *ngIf="!showEntityList && !loading && entities.length > 0" class="entity-list-container">
    <h5 class="mb-3">Todos los {{ config.entityNamePlural }} ({{ entities.length }})</h5>
    <div class="table-responsive">
      <table class="table custom-table">
        <thead>
          <tr>
            <th *ngFor="let column of config.tableColumns">{{ column.label }}</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entity of paginatedEntities" class="fade-in">
            <td *ngFor="let column of config.tableColumns">
              <span *ngIf="column.type !== 'badge'">{{ getFormattedValue(entity, column) }}</span>
              <span *ngIf="column.type === 'badge'" class="badge" [class]="getBadgeClass(entity, column)">
                {{ getFormattedValue(entity, column) }}
              </span>
            </td>
            <td>
              <div class="btn-group" role="group">
                <button *ngIf="config.actions.canView" class="btn btn-sm btn-outline-primary" (click)="viewEntity(entity)" title="Ver detalles">
                  <i class="bi bi-eye"></i>
                </button>
                <button *ngIf="config.actions.canEdit" class="btn btn-sm btn-outline-warning" (click)="editEntity(entity)" title="Editar">
                  <i class="bi bi-pencil"></i>
                </button>
                <button *ngIf="config.actions.canToggleStatus" 
                        class="btn btn-sm" 
                        [class]="getEntityActive(entity) ? 'btn-outline-secondary' : 'btn-outline-success'"
                        (click)="toggleEntityStatus(entity)" 
                        [title]="getEntityActive(entity) ? 'Desactivar' : 'Activar'">
                  <i class="bi" [class]="getEntityActive(entity) ? 'bi-pause' : 'bi-play'"></i>
                </button>
                <button *ngIf="config.actions.canDelete" class="btn btn-sm btn-outline-danger" (click)="deleteEntity(entity)" title="Eliminar">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
  <!-- Resultados de búsqueda -->
  <div *ngIf="showEntityList" class="entity-list-container">
    <h5 class="mb-3">Resultados de búsqueda ({{ filteredEntities.length }})</h5>
    
    <!-- Mensaje cuando no hay resultados -->
    <div *ngIf="filteredEntities.length === 0" class="alert alert-info" role="alert">
      <i class="bi bi-info-circle"></i> No se encontraron {{ config.entityNamePlural }} que coincidan con "{{ searchTerm }}"
    </div>
    
    <!-- Tabla de resultados -->
    <div *ngIf="filteredEntities.length > 0" class="table-responsive">
      <table class="table custom-table">
        <thead>
          <tr>
            <th *ngFor="let column of config.tableColumns">{{ column.label }}</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entity of paginatedEntities" class="fade-in">
            <td *ngFor="let column of config.tableColumns">
              <span *ngIf="column.type !== 'badge'">{{ getFormattedValue(entity, column) }}</span>
              <span *ngIf="column.type === 'badge'" class="badge" [class]="getBadgeClass(entity, column)">
                {{ getFormattedValue(entity, column) }}
              </span>
            </td>
            <td>
              <div class="btn-group" role="group">
                <button *ngIf="config.actions.canView" class="btn btn-sm btn-outline-primary" (click)="viewEntity(entity)" title="Ver detalles">
                  <i class="bi bi-eye"></i>
                </button>
                <button *ngIf="config.actions.canEdit" class="btn btn-sm btn-outline-warning" (click)="editEntity(entity)" title="Editar">
                  <i class="bi bi-pencil"></i>
                </button>
                <button *ngIf="config.actions.canToggleStatus" 
                        class="btn btn-sm" 
                        [class]="getEntityActive(entity) ? 'btn-outline-secondary' : 'btn-outline-success'"
                        (click)="toggleEntityStatus(entity)" 
                        [title]="getEntityActive(entity) ? 'Desactivar' : 'Activar'">
                  <i class="bi" [class]="getEntityActive(entity) ? 'bi-pause' : 'bi-play'"></i>
                </button>
                <button *ngIf="config.actions.canDelete" class="btn btn-sm btn-outline-danger" (click)="deleteEntity(entity)" title="Eliminar">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
  <!-- Paginación -->
  <div *ngIf="(showEntityList ? filteredEntities.length : entities.length) > 0" class="pagination-container mt-4">
    <div class="row align-items-center">
      <!-- Selector de items por página -->
      <div class="col-md-6">
        <div class="items-per-page">
          <label for="itemsPerPage" class="form-label me-2">Mostrar:</label>
          <select id="itemsPerPage" class="form-select form-select-sm d-inline-block w-auto" 
                  [(ngModel)]="itemsPerPage" (change)="changeItemsPerPage(itemsPerPage)">
            <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
          </select>
          <span class="ms-2">{{ config.entityNamePlural }} por página</span>
        </div>
      </div>
      
      <!-- Controles de paginación -->
      <div class="col-md-6">
        <nav aria-label="Paginación">
          <ul class="pagination pagination-sm justify-content-end mb-0">
            <!-- Botón anterior -->
            <li class="page-item" [class.disabled]="currentPage === 1">
              <button class="page-link" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
                <i class="bi bi-chevron-left"></i>
              </button>
            </li>
            
            <!-- Números de página -->
            <li *ngFor="let page of getPageNumbers()" class="page-item" [class.active]="page === currentPage">
              <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
            </li>
            
            <!-- Botón siguiente -->
            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <button class="page-link" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
                <i class="bi bi-chevron-right"></i>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    
    <!-- Información de página actual -->
    <div class="row mt-2">
      <div class="col-12">
        <small class="text-muted">
          Página {{ currentPage }} de {{ totalPages }} 
          ({{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, totalItems) }} de {{ totalItems }} {{ config.entityNamePlural }})
        </small>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Detalles -->
<div class="modal fade" id="entityDetailsModal" tabindex="-1" aria-labelledby="entityDetailsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="entityDetailsModalLabel">
          <i class="bi bi-person-circle me-2"></i>
          Detalles del {{ config.entityName | titlecase }}
        </h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      
      <div class="modal-body" *ngIf="selectedEntity">
        <!-- Loading state -->
        <div *ngIf="loadingEntityDetails" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando detalles...</span>
          </div>
          <p class="mt-2 text-muted">Cargando detalles del {{ config.entityName }}...</p>
        </div>
        
        <!-- Entity details content -->
        <div *ngIf="!loadingEntityDetails" class="user-details-content">
          <!-- Secciones dinámicas -->
          <div *ngFor="let section of config.modalSections" class="detail-section">
            <h6 class="section-title">
              <i class="bi {{ section.icon }} me-2"></i>
              {{ section.title }}
            </h6>
            <div class="row">
              <div class="col-md-6" *ngFor="let field of section.fields; let i = index">
                <div class="detail-item" *ngIf="shouldShowField(field, selectedEntity)">
                  <label>{{ field.label }}:</label>
                  <span *ngIf="field.type !== 'badge'">{{ getModalFieldValue(selectedEntity, field) }}</span>
                  <span *ngIf="field.type === 'badge'" class="badge" [class]="getModalBadgeClass(selectedEntity, field)">
                    {{ getModalFieldValue(selectedEntity, field) }}
                  </span>
                </div>
                <!-- Salto de columna cada 2 campos -->
                <div class="w-100" *ngIf="i % 2 === 1 && i !== section.fields.length - 1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          <i class="bi bi-x-circle me-1"></i>
          Cerrar
        </button>
        <button *ngIf="config.actions.canEdit" type="button" class="btn btn-warning" (click)="editEntity(selectedEntity!)" data-bs-dismiss="modal">
          <i class="bi bi-pencil me-1"></i>
          Editar {{ config.entityName | titlecase }}
        </button>
      </div>
    </div>
  </div>
</div>
